import React, { useRef } from 'react';
import { Button, Stack } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';

const UploadLogoButton = ({ onFileSelected, onError, label = 'Subir logo', disabled = false }) => {
  const inputRef = useRef();

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!['image/png', 'image/jpeg'].includes(file.type)) {
        onError?.('El logo debe ser una imagen PNG o JPEG.');
      } else if (file.size > 200 * 1024) {
        onError?.('El logo no puede exceder los 200 KB.');
      } else {
        onError?.('');
        onFileSelected(file);
      }
      event.target.value = '';
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      <input
        type="file"
        accept="image/png,image/jpeg"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <Button
        variant="contained"
        startIcon={<UploadIcon />}
        onClick={handleButtonClick}
        disabled={disabled}
        sx={{ textTransform: 'none', borderRadius: 2 }}
      >
        {label}
      </Button>
    </Stack>
  );
};

export default UploadLogoButton;
